if (!customElements.get("cart-toast")) {
  customElements.define(
    "cart-toast",
    class CartToast extends HTMLElement {
      constructor() {
        super();
        this.hide = this.hide.bind(this);
      }

      connectedCallback() {
        this.titleElement = this.querySelector("[data-cart-toast-title]");
        this.copyElement = this.querySelector("[data-cart-toast-copy]");
        this.closeButtons = this.querySelectorAll("[data-cart-toast-close]");
        this.closeButtons.forEach((button) => button.addEventListener("click", this.hide));
      }

      disconnectedCallback() {
        this.closeButtons?.forEach((button) => button.removeEventListener("click", this.hide));
        window.clearTimeout(this.timeoutId);
      }

      show({ title, copy } = {}) {
        if (title) this.titleElement.textContent = title;
        if (copy) this.copyElement.textContent = copy;

        this.hidden = false;
        this.setAttribute("open", "");

        window.clearTimeout(this.timeoutId);
        this.timeoutId = window.setTimeout(() => {
          this.hide();
        }, 4500);
      }

      hide() {
        this.hidden = true;
        this.removeAttribute("open");
        window.clearTimeout(this.timeoutId);
      }
    }
  );
}
